import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../../../core/abstracts/baseComponent';
import { daysBetween, deepClone } from '../../../../helpers/utils';
import { MyEmployeeReferralModel } from '../../../../models/employeeReferralModel';
import { PagingResultsModel } from '../../../../models/pagingResultsModel';
import { ActivatedRoute, Router } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { State } from '../../../../core/store';
import { tap } from 'rxjs';
import { getMyReferrals, saveEmployeeReferralSuccess, createReferralFormSubmission, createReferralFormSubmissionSuccess } from '../../../../core/store/queues/queues.action';
import { AlertService } from '../../../../shared/services/alert.service';

@Component({
  selector: 'app-my-referrals',
  templateUrl: './my-referrals.component.html',
  styleUrls: ['./my-referrals.component.scss'],
  standalone: false
})
export class MyReferralsComponent extends BaseComponent implements OnInit {
  list: PagingResultsModel<MyEmployeeReferralModel>;
  filter: any;
  loadingList: boolean = true;
  saving: boolean = false;  

  yesNoAllOptions = [
    { label: 'All', value: null },
    { label: 'Yes', value: true },
    { label: 'No', value: false },
  ];

  archivedReferralsFilter?: boolean = false;
  rejectedReferralsFilter?: boolean = false;


  constructor(
    private router: Router,
    private actions$: Actions,
    private store: Store<State>,
    private route: ActivatedRoute,
    private alertService: AlertService) {
    super();
  }

  ngOnInit(): void {
    this.subs.push(
      this.store.select(s => s.queuesState.loadingMyEmployeeReferralList).subscribe(loadingEmployeeReferralList => {
        this.loadingList = loadingEmployeeReferralList;
      }),
      this.store.select(s => s.queuesState.savingReferralBonus).subscribe(savingReferralBonus => {
        this.saving = savingReferralBonus;
      }),
      this.store.select(s => s.queuesState.myReferralList).subscribe(employeeReferralList => {
        this.list = deepClone(employeeReferralList);
      }),      
      this.actions$.pipe(
        ofType(saveEmployeeReferralSuccess),
        tap(action => {
          this.reloadList();
        })
      ).subscribe(),
      this.actions$.pipe(
        ofType(createReferralFormSubmissionSuccess),
        tap(action => {
          this.alertService.success("Referral form created");
          this.reloadList();
        })
      ).subscribe(),
    );
  }

  reloadFilter(event) {
    this.filter = event;
    this.reloadList();
  }

  reloadList() {
    this.filter = deepClone(this.filter);
    this.filter.filters.showArchivedReferrals = { Name: 'showArchivedReferrals', Value: { value: this.archivedReferralsFilter } };
    this.filter.filters.showRejectedReferrals = { Name: 'showRejectedReferrals', Value: { value: this.rejectedReferralsFilter } };

    this.store.dispatch(getMyReferrals({
      filter: this.filter
    }));
  }


  getNewHireDaysAfterHire(referral: MyEmployeeReferralModel) {
    if (referral.newHireTrainingStartDate != null) {
      return " (" + daysBetween(new Date(referral.newHireTrainingStartDate), new Date()) + ")";
    }

    return "";
  }

  getNewHireDetailsString(referral: MyEmployeeReferralModel) {
    if (referral.newHireUserID == null || referral.newHireUserID <= 0) {
      return "(Not Hired)";
    }

    if (referral.newHireTerminationDate != null) {
      return "(Separated)";
    }

    if (referral.newHireInactive) {
      return "(Inactive)"
    }

    return "";
  }


  hasSignedForm(referral: MyEmployeeReferralModel) {
    return referral.formSubmissionID > 0 && referral.formSignedDate != null;
  }

  hasFormToSign(referral: MyEmployeeReferralModel) {
    return referral.formSubmissionID > 0 && referral.formSignedDate == null;
  }

  showCreateFormButton(referral: MyEmployeeReferralModel) {
    if (referral.formSubmissionID > 0) {
      return false;
    }

    return referral.hasDefaultForm;
  }

  createReferralForm(referral: MyEmployeeReferralModel) {
    this.store.dispatch(createReferralFormSubmission({ referralId: referral.id }));
  }

  viewForm(referral: MyEmployeeReferralModel) {
    if (referral.formSubmissionID > 0) {
      this.router.navigate(['../../form-filling/form-submission/0/' + referral.formSubmissionID], { queryParams: { backLink: '../../../../referrals/my' }, relativeTo: this.route });
    }
  }

  fillForm(referral: MyEmployeeReferralModel) {
    if (referral.formSubmissionID > 0) {
      this.router.navigate(['../../form-filling/fill/0/' + referral.formSubmissionID], { queryParams: { backLink: '../../../../referrals/my' }, relativeTo: this.route });
    }
  }
}
